export default __webpack_public_path__ + "static/illu-usages-5ba8998d0755d00eb78b9dc2c7298381.png";